import type { DevState } from 'app/store/dev/dev.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectDevState } from 'app/store/dev/dev.state';
import * as fromDocuments from './documents.reducer';

export const devDocumentsState = createSelector(
  selectDevState,
  state => state.documents,
);

export const devDocuments = createSelector(
  selectDevState,
  state => fromDocuments.selectAll(state.documents),
);

export const oneDevDocument = createSelector(
  selectDevState,
  (state: DevState, props: { id: Uuid }) => fromDocuments.selectEntities(state.documents)[props.id],
);

export const renderClasses = createSelector(
  selectDevState,
  state => state.documents.renderClasses,
);
